import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-aceite-popup',
  templateUrl: './orientacoes-aceite.component.html',
  styleUrls: ['./orientacoes-aceite.component.css']
})
export class OrientacoesAceiteComponent implements AfterViewInit {

  constructor(private cdr: ChangeDetectorRef) { }

  @ViewChild('aceiteContent') aceiteContent!: ElementRef<HTMLElement>;
  @Input() origem: string;
  @Input() isVisible;
  @Output() closed = new EventEmitter<void>();

  showButton = true;
  conteudoHtml;

  ngAfterViewInit(): void {
    const el = this.aceiteContent.nativeElement;
    el.focus();
    this.checkScroll();
    this.cdr.detectChanges();
  }

  onScroll(): void {
    this.checkScroll();
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    const keys = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End'];
    if (keys.includes(event.code) && this.aceiteContent.nativeElement === document.activeElement) {
      setTimeout(() => this.checkScroll(), 0);
    }
  }

  private checkScroll() {
    const el = this.aceiteContent.nativeElement;
    const scrollTop = el.scrollTop;
    const maxScroll = el.scrollHeight - el.clientHeight;
    this.showButton = scrollTop >= maxScroll - 10 || this.isVisible;
  }

  // Adicione a variável aceitouTermos que usamos no HTML
  public aceitouTermos: boolean = false;

  // Altere a função closePopup para emitir o sinal de confirmação
  closePopup(): void {
    this.isVisible = false;
    this.closed.emit(); // Isso avisa o componente pai que o usuário aceitou
  }


}
